// Action Types
export const LIST_DEALS_REQUEST = "LIST_DEALS_REQUEST";
export const LIST_DEALS_SUCCESS = "LIST_DEALS_SUCCESS";
export const LIST_DEALS_FAILURE = "LIST_DEALS_FAILURE";

// Action Creators

export const listDealsRequestPlain = ({ userId }) => ({
  type: LIST_DEALS_REQUEST,
  payload: { userId },
});

export const listDealsRequest = ({userId}) => {
  return (dispatch) => {
    dispatch({
      type: LIST_DEALS_REQUEST,
      payload: {userId},
    });
  };
};

export const listDealsSuccess = (data) => ({
  type: LIST_DEALS_SUCCESS,
  payload: data,
});

export const listDealsFailure = (error) => ({
  type: LIST_DEALS_FAILURE,
  payload: error,
});